import { Divider, Typography } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import InfoBox from '@/components/InfoBox';

import style from './index.less';

const { Text } = Typography;

const FormTitleSession = ({ translate, title, description, className, divider, customDescription, ...props }) => {
  const { t } = useTranslation(translate);
  return (<div className={classNames('md:mt-3 md:mb-4 my-2', className)}>
    <Text className={classNames('font-extrabold', style.titleText, className)} {...props}>
      {t(title)}
    </Text>
    {customDescription && <InfoBox renderTitle={() => customDescription} textClassName="mr-4" {...props}/>}
    {description && <InfoBox title={t(description)} textClassName="mr-4" {...props}/>}
    {divider && <Divider className="my-0 mt-1"/>}
  </div>);
};

export default memo(FormTitleSession);

FormTitleSession.propTypes = {
  translate: PropTypes.string,
  customDescription: PropTypes.any,
  className: PropTypes.string,
  description: PropTypes.string,
  help: PropTypes.string,
  divider: PropTypes.bool,
  title: PropTypes.string
};
